import React, { useEffect, useState } from "react";
import Tarjetas from "../components/Tarjetas";
import supabase from "../config/supabaseClient";
import estilo from "../styles/Buscar.module.css";
import MetaDecorator from "../utils/MetaDecorator";

function Buscar() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [vacio, setVacio] = useState(null);
  const [input, setInput] = useState("");
  const [lista, setLista] = useState([]);

  const submitHandler = async (e) => {
    e.preventDefault();

    var inputFinal;

    input === "" || input === " "
      ? (inputFinal = null)
      : (inputFinal = input.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));

    const { data, error } = await supabase
      .from("anime")
      .select()
      .ilike("nombre", `%${inputFinal}%`)
      .range(0, 11);

    if (error) {
      console.log(error);
      setLista([]);
    }
    if (data.length === 0) {
      setLista([]);
      setVacio("No hay resultados...");
      console.log("vacio");
    } else if (data) {
      setLista(data);
      setVacio(null);
      // console.log("data: ", data);
    }
  };

  return (
    <div className={estilo.contenedor_buscar}>
      <MetaDecorator
        titulo={"Buscar en la Lista de animes disponibles | yTAnimeTV"}
        subtitulo={"ytanimetv.com"}
        descripcion={
          "Buscar y encuentra tu anime favorito en la mejor pagina para Ver Anime Online en subtitulados al Español, mira los ultimos capitulos de los animes actuales totalmente gratis."
        }
        keywords={
          "anime online español, anime online gratis, anime online naruto, anime online naruto shippuden, anime online sub español, anime online free, anime online latino, anime online bleach, animes, anime, ecchi, anime online, Naruto Shippuden, Anime online, Anime en Descarga Directa, Ver Anime Online."
        }
        url={"https://ytanimetv.com/buscar"}
        canonical={"https://ytanimetv.com/buscar"}
      />
      <form onSubmit={submitHandler} className={estilo.formulario}>
        <input
          onChange={(e) => setInput(e.target.value)}
          type="text"
          placeholder="Buscar"
          value={input}
        />

        <button>Buscar</button>
      </form>

      {vacio && (
        <div className={estilo.resultado}>
          <p>{vacio}</p>
        </div>
      )}

      <div className={estilo.tarjetas_grid}>
        {lista.map((e) => (
          <Tarjetas key={e.id} lista={e}></Tarjetas>
        ))}
      </div>
    </div>
  );
}

export default Buscar;
